type LegalLink = {
  href: string;
  label: string;
};

const legalLinks: LegalLink[] = [
  { href: '/terms.html', label: 'Terms' },
  { href: '/privacy.html', label: 'Privacy' },
  { href: '/dmca.html', label: 'DMCA' },
  { href: '/2257.html', label: '2257' },
  { href: '/contact.html', label: 'Contact' },
];

type LegalFooterProps = {
  className?: string;
};

export const LegalFooter = ({ className = '' }: LegalFooterProps) => (
  <footer className={className}>
    <p className="text-center text-xs font-semibold text-white/90">
      This website contains adult material (18+ only)
    </p>
    <div className="mt-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-white/90">
      {legalLinks.map((link, index) => (
        <span key={link.label} className="inline-flex items-center gap-2">
          <a href={link.href} target="_blank" rel="noreferrer" className="underline underline-offset-2">
            {link.label}
          </a>
          {index < legalLinks.length - 1 ? <span className="text-white/55">|</span> : null}
        </span>
      ))}
    </div>
  </footer>
);
